/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Portfolio_Page_Meta_DescriptionInputs */

const en_create_portfolio_page_meta_description = /** @type {(inputs: Create_Portfolio_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Glider’s assistant workspace in portfolio construction mode.`)
};

const de_create_portfolio_page_meta_description = /** @type {(inputs: Create_Portfolio_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnen Sie den Assistant-Arbeitsbereich von Glider im Portfolio-Konstruktionsmodus.`)
};

const pt_br2_create_portfolio_page_meta_description = /** @type {(inputs: Create_Portfolio_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra o espaço de trabalho do assistente da Glider no modo de construção de portfólio.`)
};

const tr_create_portfolio_page_meta_description = /** @type {(inputs: Create_Portfolio_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider'ın asistan çalışma alanını portföy oluşturma modunda açın.`)
};

const zh_cn2_create_portfolio_page_meta_description = /** @type {(inputs: Create_Portfolio_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以投资组合搭建模式打开 Glider 助手工作区。`)
};

const zh_hk2_create_portfolio_page_meta_description = /** @type {(inputs: Create_Portfolio_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以投資組合建立模式開啟 Glider 助手工作區。`)
};

const ko_kr2_create_portfolio_page_meta_description = /** @type {(inputs: Create_Portfolio_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포트폴리오 구성 모드에서 Glider의 어시스턴트 작업 공간을 여세요.`)
};

const ru_ru2_create_portfolio_page_meta_description = /** @type {(inputs: Create_Portfolio_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откройте рабочее пространство помощника Glider в режиме создания портфеля.`)
};

const es_419_create_portfolio_page_meta_description = /** @type {(inputs: Create_Portfolio_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abre el espacio de trabajo del asistente de Glider en modo de construcción de portafolios.`)
};

/**
* | output |
* | --- |
* | "Open Glider’s assistant workspace in portfolio construction mode." |
*
* @param {Create_Portfolio_Page_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const create_portfolio_page_meta_description = /** @type {((inputs?: Create_Portfolio_Page_Meta_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Portfolio_Page_Meta_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_portfolio_page_meta_description(inputs)
	if (locale === "de") return de_create_portfolio_page_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_create_portfolio_page_meta_description(inputs)
	if (locale === "tr") return tr_create_portfolio_page_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_create_portfolio_page_meta_description(inputs)
	if (locale === "zh-HK") return zh_hk2_create_portfolio_page_meta_description(inputs)
	if (locale === "ko-KR") return ko_kr2_create_portfolio_page_meta_description(inputs)
	if (locale === "ru-RU") return ru_ru2_create_portfolio_page_meta_description(inputs)
	return es_419_create_portfolio_page_meta_description(inputs)
});